// extracted by mini-css-extract-plugin
export default {"root":"colorRectangle_root__xHHs9","label":"colorRectangle_label__QlCgv"};